export enum AcceptedFileExtensions {
  xlsx = 'xlsx',
  xls = 'xls',
  ppt = 'ppt',
  pptx = 'pptx',
  docx = 'docx',
  csv = 'csv',
  png = 'png',
  jpg = 'jpg',
  pdf = 'pdf',
  zip = 'zip',
}
